//-------------------------------------------------------------------------------------------------- Imports
import React, { useCallback } from 'react';
import { Button, Card, Checkbox, Col, Input, Row, Tooltip, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { InfoCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import _ from 'lodash';
import SwipeableButton from '../../../components/SwipeableButton';
import moment from "moment";
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../stores/store';
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from '../../../stores/slices/alertSlice';
import { Link } from 'react-router-dom';
import { images } from '../../../routes/ImageRoutes';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import DisabledSwipeableButton from '../../../components/DisabledSwipeableButton';
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- Inteface
interface PaymentCardProps {
    functionRecharge: (carData: CardRechargeProps) => void;
};

interface errorFieldsProps {
    creditCard: string;
    name: string;
    expirationCard?: string;
    cvvCard?: string;
    expirationCardSaved?: string;
    cvvCardSaved?: string;
};

export interface CardRechargeProps {
    number: string;
    name: string;
    cvvCard: string;
    expirationDateCard: string;
};

//-------------------------------------------------------------------------------------------------- View
const PaymentCard = (props: PaymentCardProps) => {
    const { functionRecharge } = props;
    const emptyErrorFields: errorFieldsProps = {
        creditCard: "",
        name: "",
        expirationCard: "",
        cvvCard: ""
    }
    const [cardNumber, setCardNumber] = React.useState("");
    const [cardName, setCardName] = React.useState("");
    const [cvvCar, setCvvCard] = React.useState("");
    const [expCard, setExpCard] = React.useState("");
    const [cardEnd, setCardEnd] = React.useState("");
    const [cardToPay, setCardToPay] = React.useState<CardRechargeProps>({
        expirationDateCard: "",
        cvvCard: "",
        number: "",
        name: ""
    });
    const [confirmStep, setConfirmStep] = React.useState<boolean>(false);
    const [checked, setChecked] = React.useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>();
    const [errorsEmptyFields, setErrorsEmptyFields] = React.useState<errorFieldsProps>(emptyErrorFields);

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            extraComponents: option.extraComponents,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const onChangeCheck = (e: CheckboxChangeEvent) => {
        setChecked(e.target.checked);
    };

    const handleCardNumNew = (inputValue: string) => {
        errorsEmptyFields.creditCard = "";
        var numberRaw = inputValue.split("-").join("");
        var numberFormated = inputValue.match(new RegExp('.{1,4}', 'g'))?.join("-");
        if (numberRaw.length <= 16) {
            if (numberFormated) {
                setCardNumber(numberFormated);
            } else {
                setCardNumber("");
            }
        }
    };

    const handleCardCvvNew = (inputValue: string) => {
        errorsEmptyFields.cvvCard = "";
        const numericValue = inputValue.replace(/[^0-9]/g, '');
        setCvvCard(numericValue);
    };

    const handleCardExpNew = (inputValue: string) => {
        errorsEmptyFields.expirationCard = "";
        const numericValue = inputValue.replace(/[^0-9]/g, '');
        setExpCard(numericValue);
    };

    const handleCardName = (inputValue: string) => {
        errorsEmptyFields.name = "";
        setCardName(inputValue);
    };

    const validateData = () => {
        let messageField = "El campo está vacío.\n";
        var reg = new RegExp("(0[1-9]|1[012])/[0-9]{2}");
        let error = "";
        let hasErrorMMAA = true;
        let hasErrorCvv = true;

        let errorFields: errorFieldsProps = {
            creditCard: "",
            expirationCard: "",
            cvvCard: "",
            expirationCardSaved: "",
            cvvCardSaved: "",
            name: ''
        }

        let cardNumberLenght = cardNumber.match(/[0-9]/g)?.length;

        if (!cardNumberLenght || cardNumberLenght < 16) {
            let message = "La tarjeta debe tener 16 dígitos.\n";
            error += message;
            errorFields.creditCard = "Campo debe ser a 16 dígitos.";
        }
        if (!cardNumber) {
            let message = "El campo nombre del titular está vacío.\n";
            error += message;
            errorFields.name = messageField;
        }
        if (!cardNumber) {
            let message = "El campo número de tarjeta está vacío.\n";
            error += message;
            errorFields.creditCard = messageField;
        }
        if (!cvvCar) {
            let message = "El campo cvv está vacío.\n";
            error += message;
            errorFields.cvvCard = messageField;
        } else if (cvvCar.length < 3) {
            let message = "El campo debe ser a 3 dígitos.\n";
            error += message;
            errorFields.cvvCard = message;
        } else {
            hasErrorCvv = false;
        }
        if (!expCard) {
            let message = "El campo vencimiento está vacío.\n";
            error += message;
            errorFields.expirationCard = messageField;
        }
        else {
            let expDate = expCard.replace(/(\d{2})(\d{2})/, "$1/$2")
            if (reg.test(expDate))
                hasErrorMMAA = false;
            else {
                if (expDate.indexOf("/") < 0) {
                    let message = "El campo MM/AA es incongruente.\n";
                    error += message;
                    errorFields.expirationCard = message;
                } else {
                    let message = "El campo Mes (MM) y/o año (AA) es incorrecto.\n";
                    error += message;
                    errorFields.expirationCard = message;
                }
            }
            let mes = expDate.slice(0, 2);
            let mesActual = moment().format("MM");
            let anio = expDate.slice(3, 5);
            let anioActual = moment().format("YY");

            if (!_.isEmpty(anio) && !_.isEmpty(mes)) {
                if (anio === anioActual && mes < mesActual) {
                    let message = "El mes de la tarjeta ha expirado.\n";
                    error += message;
                    errorFields.expirationCard = "El mes ha expirado.";
                }
                if (anio < anioActual) {
                    let message = "El año de la tarjeta ha expirado.\n";
                    error += message;
                    errorFields.expirationCard = "El año ha expirado.";
                }
            }
        }

        setErrorsEmptyFields(errorFields);

        if (error !== "") {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        }

        // Si cumple con todas las validaciones 
        if (!hasErrorMMAA && !hasErrorCvv && error === "") {
            setConfirmStep(true);

            let cardDataObj: CardRechargeProps;

            cardDataObj = {
                // quita los guiones con los que se guardaba en el input
                number: cardNumber.split("-").join(''),
                name: cardName,
                cvvCard: cvvCar,
                expirationDateCard: expCard
            }
            setCardEnd(cardDataObj.number.substring(12, 16))

            setCardToPay(cardDataObj);
        }
    };

    return (
        <Card style={styles.cardView}>
            {(confirmStep) ? (
                <>
                    <Button style={styles.buttonGoBackC}
                        type="primary"
                        onClick={() => setConfirmStep(false)}
                    >
                        <LeftOutlined />
                        <Text style={styles.goBackConfirm}>{"Regresar"}</Text>
                    </Button>
                    <Row style={styles.rowViewTitleC}>
                        <Col xs={20}>
                            <Text style={styles.textTitleSecond}>{"Confirmación de pago"}</Text>
                        </Col>
                        <Col xs={4}>
                            <img style={styles.imageStores} src={images.megaLogo} alt="Mega Logo" />
                        </Col>
                    </Row>
                    <Text style={{ fontWeight: 600 }}>¡Estimado usuario!</Text>
                    <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
                        <Col xs={24} xl={15}>
                            <Text style={styles.inputTitle}>
                                {"¿Desea continuar con el pago de su recarga con la tarjeta con terminación " + cardEnd + "?"}
                            </Text>
                        </Col>
                        <Col xs={24} xl={15}>
                            <Text style={styles.inputTermsAndC}>{"Para realizar el pago, favor de aceptar Los términos y condiciones y deslizar el botón hacia la derecha"}</Text>
                        </Col>

                        <Col xs={24} xl={13}>
                            <Link
                                style={{ color: "#1d5092", textDecoration: 'underline' }}
                                to={'https://www.megacable.com.mx/terminos-y-condiciones'}
                                target='_blank'
                            >
                                Términos y Condiciones.
                            </Link>
                        </Col>
                        <Col xs={24} xl={11} >
                            <div style={styles.rowViewTerms}>
                                <Checkbox style={{ width: "20%" }} onChange={onChangeCheck} ></Checkbox>
                                <Text style={styles.inputTermsAgree}>{"Estoy de acuerdo con los Términos y Condiciones de Uso"}</Text>
                            </div>
                        </Col>
                        <Col xs={24} style={styles.colSwipConfirm}>
                            <div style={{ width: "80%" }}>
                                {
                                    checked ?
                                        <SwipeableButton
                                            onSuccess={() => functionRecharge(cardToPay)}
                                            color='#0055c2'
                                            text='Deslice para confirmar'
                                        />
                                        :
                                        <DisabledSwipeableButton color='gray' text='Deslice para confirmar' />
                                }
                            </div>
                        </Col>
                    </Row>
                </>
            ) : (
                <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
                    <Col xs={24}>
                        <Text style={styles.inputTitle}>Nombre del titular</Text>
                        <Input
                            value={cardName}
                            style={styles.inputText}
                            placeholder='Nombre del titular'
                            onChange={(element) => handleCardName(element.target.value)}
                            status={errorsEmptyFields.name ? "error" : ""}
                            suffix={
                                <Tooltip title={`Nombre del titular de la tarjeta.`} >
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                        {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.name ? errorsEmptyFields.name : null}</Text>}
                    </Col>
                    <Col xs={24}>
                        <Text style={styles.inputTitle}>Número de Tarjeta</Text>
                        <Input
                            value={cardNumber}
                            style={styles.inputText}
                            placeholder='0000 0000 0000 0000'
                            onChange={(element) => handleCardNumNew(element.target.value.replace(/[^0-9]/g, ''))}
                            status={errorsEmptyFields.creditCard ? "error" : ""}
                            maxLength={19}
                        />
                        {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.creditCard ? errorsEmptyFields.creditCard : null}</Text>}
                    </Col>
                    <Col xs={24} xl={12}>
                        <Text style={styles.inputTitle}>Vencimiento</Text>
                        <Input
                            value={expCard.replace(/(\d{2})(\d{2})/, "$1/$2")}
                            style={styles.inputText}
                            placeholder='mm/aa'
                            onChange={(element) => handleCardExpNew(element.target.value)}
                            status={errorsEmptyFields.expirationCard ? "error" : ""}
                            maxLength={5}
                            suffix={
                                <Tooltip title={`Fecha de vencimiento: Fecha ubicada al frente de tu tarjeta, debajo del número de tarjeta.`} >
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                        {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.expirationCard ? errorsEmptyFields.expirationCard : null}</Text>}
                    </Col>
                    <Col xs={24} xl={12}>
                        <Text style={styles.inputTitle}>CVV</Text>
                        <Input
                            value={cvvCar}
                            style={styles.inputText}
                            placeholder='000'
                            onChange={(element) => handleCardCvvNew(element.target.value)}
                            status={errorsEmptyFields.cvvCard ? "error" : ""}
                            maxLength={3}
                            suffix={
                                <Tooltip title={`CVV: Código de 3 dígitos, situado al reverso de tu tarjeta.`} >
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                        {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.cvvCard ? errorsEmptyFields.cvvCard : null}</Text>}
                    </Col>
                    <Col xs={24} style={styles.colPayButton}>
                        <Button
                            size='large'
                            style={styles.buttonPrimary}
                            onClick={validateData}
                        >
                            {"Pagar con esta tarjeta"}
                            <RightOutlined />
                        </Button>
                    </Col>
                </Row>
            )}
        </Card >
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardViewRoot: {
        backgroundColor: 'white',
        borderRadius: 15,
        marginBottom: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)"
    },
    cardView: {
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    },
    cardViewPay: {
        cursor: 'pointer',
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    },
    textTitleSecond: {
        fontSize: 15,
        color: "#00339D",
        fontWeight: 600,
    },
    textTitle: {
        fontSize: 15,
        color: "#767b81",
        fontWeight: 600,
    },
    rowViewTitleC: {
        display: 'flex',
        alignItems: 'center'
    },
    rowViewSecure: {
        display: 'flex',
        justifyContent: 'center'
    },
    rowViewTerms: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    rowViewPaymentData: {
        marginTop: 10
    },
    colPayButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 10,
    },
    colSwipConfirm: {
        display: 'flex',
        justifyContent: 'center'
    },
    colCardNumber: {
        width: "100%",
        justifyContent: 'center',
        display: 'flex',
        marginTop: 10
    },
    goBackConfirm: {
        color: "white"
    },
    saveCardText: {
        color: "#767b81",
        fontWeight: 600,
    },
    icon: {
        fontSize: 15,
        color: "#767b81"
    },
    inputContainer: {
        width: "80%",
    },
    inputText: {
        marginTop: 10,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    emptyFieldError: {
        fontSize: 11
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputTermsAndC: {
        color: "black",
        fontWeight: 600
    },
    inputTermsAgree: {
        color: "black",
        fontSize: 10,
        width: "80%"
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 20,
        color: 'white',
        border: "none"
    },
    buttonGoBackC: {
        backgroundColor: '#00339D',
        borderRadius: 20,
        color: 'white',
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10
    },
    imageStores: {
        height: 50
    },
    imageSecure: {
        height: 50
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default PaymentCard;
